import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpMarketingQueuePage } from '@/features/pcmp/pages/PcmpMarketingQueuePage';
import { pcmpMarketingQueueSearchSchema } from '@/features/pcmp/types/pcmpMarketing.types';

export const Route = createFileRoute('/_auth/pcmp/marketing/')({
  validateSearch: pcmpMarketingQueueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Marketing">
      <Suspense fallback={<PageLoader />}>
        <PcmpMarketingQueuePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
